class NuviaBundleOffer extends HTMLElement {
  connectedCallback() {
    this.state = JSON.parse(this.querySelector('[data-offer-data]').textContent);
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('change', event => {
      const target = event.target;
      if (target.matches('[data-kit-color]')) {
        const radio = Array.from(document.querySelectorAll('variant-picker input[type="radio"]')).find(input => input.value === target.value);
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      this.sync();
    }, options);
    document.addEventListener('variant:update', () => queueMicrotask(() => this.sync()), options);
    document.addEventListener('click', event => {
      const button = event.target.closest('sticky-add-to-cart button');
      if (!button || this.offer !== 'kit') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.addKit();
    }, { ...options, capture: true });
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!form.closest('product-form-component') || this.offer !== 'kit') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.addKit();
    }, { ...options, capture: true });
    document.addEventListener('scroll', () => this.syncSticky(), { ...options, passive: true });
    window.addEventListener('resize', () => this.syncSticky(), options);
    this.sync();
    this.syncSticky();
  }
  syncSticky() {
    const button = document.querySelector('product-form-component button[type="submit"]');
    const bar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
    if (!button || !bar) return;
    const footer = document.querySelector('footer,[role="contentinfo"]');
    const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
    bar.setAttribute('data-stuck', String(button.getBoundingClientRect().bottom < 0 && !footerVisible));
  }
  disconnectedCallback() { this.controller?.abort(); }
  get offer() { return this.querySelector('input[name="navira-offer"]:checked')?.value || 'solo'; }
  get color() { return document.querySelector('variant-picker input:checked')?.value || 'Violeta'; }
  sync() {
    const kit = this.offer === 'kit';
    this.querySelector('[data-kit-contents]').hidden = !kit;
    this.querySelectorAll('[data-offer-card]').forEach(card => card.classList.toggle('navira-offer--selected', card.dataset.offerCard === this.offer));
    this.querySelector('[data-kit-color]').value = this.color;
    const variant = this.state.solo.find(item => item.option1 === this.color);
    const image = variant?.featured_image?.src;
    if (image) this.querySelector('[data-sensora-picture]').src = image;
    const formComponent = document.querySelector('product-form-component');
    if (formComponent) {
      if (!formComponent.dataset.naviraSubmitAction) formComponent.dataset.naviraSubmitAction = formComponent.getAttribute('on:submit') || '/handleSubmit';
      if (kit) formComponent.removeAttribute('on:submit');
      else formComponent.setAttribute('on:submit', formComponent.dataset.naviraSubmitAction);
    }
    const stickyButton = document.querySelector('sticky-add-to-cart button');
    if (stickyButton) {
      stickyButton.setAttribute('aria-label', 'Agregar al carrito');
      if (kit) stickyButton.removeAttribute('on:click');
      else stickyButton.setAttribute('on:click', '/handleAddToCartClick');
    }
    const price = kit ? this.state.kitPrice : this.state.soloPrice;
    const compare = kit ? this.state.kitCompare : this.state.soloCompare;
    const money = amount => new Intl.NumberFormat('es-MX', { style:'currency', currency:this.state.currency || 'MXN', maximumFractionDigits:2 }).format(amount/100)+' '+(this.state.currency || 'MXN');
    const headlinePrice = this.state.soloPrice;
    const headlineCompare = this.state.soloCompare;
    const priceElement = document.querySelector('.elera-price__now');
    if (priceElement) priceElement.textContent = money(headlinePrice);
    const was = document.querySelector('.elera-price__was');
    if (was) { was.hidden = !(headlineCompare > headlinePrice); was.textContent = headlineCompare > headlinePrice ? money(headlineCompare) : ''; }
    const save = document.querySelector('.elera-price__save');
    if (save) { save.hidden = !(headlineCompare > headlinePrice); save.textContent = headlineCompare > headlinePrice ? 'Ahorras '+money(headlineCompare-headlinePrice)+' hoy' : ''; }
    const badge = document.querySelector('.elera-price__badge');
    if (badge) { badge.hidden = !(headlineCompare > headlinePrice); badge.textContent = headlineCompare > headlinePrice ? '-'+Math.round((headlineCompare-headlinePrice)*100/headlineCompare)+'%' : ''; }
    const sticky = document.querySelector('sticky-add-to-cart');
    if (sticky) {
      const title = sticky.querySelector('.sticky-add-to-cart__title');
      if (title) title.textContent = kit ? 'Nuvia Kit esencial' : 'Nuvia Sensora - TripleWave™';
      const display = sticky.querySelector('.sticky-add-to-cart__price');
      if (display) {
        const currentPrice = document.createElement('span');
        currentPrice.textContent = money(price);
        display.replaceChildren(currentPrice);
        if (compare > price) {
          const previousPrice = document.createElement('s');
          previousPrice.style.fontSize = '12px';
          previousPrice.style.opacity = '.55';
          previousPrice.textContent = money(compare);
          display.append(' ', previousPrice);
        }
      }
    }
  }
  async addKit() {
    if (this.busy) return;
    this.busy = true;
    const error = this.querySelector('.navira-offers__error');
    error.hidden = true;
    const buttons = document.querySelectorAll('product-form-component button[type="submit"],sticky-add-to-cart button');
    buttons.forEach(button => button.disabled = true);
    try {
      const variant = this.state.kit.find(item => item.option1 === this.color);
      if (!variant?.available) throw new Error('Este kit no está disponible en el color seleccionado.');
      const sections = Array.from(document.querySelectorAll('cart-items-component')).map(item=>item.dataset.sectionId).filter(Boolean);
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,properties:{'E-book de regalo':'Tu momento: guía para reconectar contigo'}}],sections,sections_url:window.location.pathname})});
      const added = await response.json();
      if (!response.ok) throw new Error(added.description || 'No se pudo agregar el kit. Inténtalo nuevamente.');
      const cart = await fetch(root+'cart.js').then(result=>result.json());
      document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:cart,sourceId:'navira-bundle',data:{source:'navira-bundle',sections:added.sections,itemCount:1,variantId:String(variant.id)}}}));
      document.querySelector('header-component button[aria-label="Carrito"]')?.click();
    } catch (failure) { error.textContent = failure.message; error.hidden = false; }
    finally { this.busy=false; buttons.forEach(button=>button.disabled=false); }
  }
}
if (!customElements.get('navira-bundle-offer')) customElements.define('navira-bundle-offer',NuviaBundleOffer);


